import { AppRoutes } from "./routes";

/** The layout every page shares. */
export function App() {
  return (
    <main className="flex flex-col gap-6 min-h-screen items-center justify-center bg-surface-canvas text-text-primary">
      <AppRoutes />
    </main>
  );
}
